module.exports = __webpack_public_path__ + "static/media/G1-41-Hillare-Philemon-Ev-cod82.722b1489.png";